/* eslint-disable max-len */
export const reportMessages = {
    'Report.Header.createdOn': 'Created On',
    'Report.Header.period': 'Period',
    'Report.Header.preparedFor': 'Prepared For',
    'Report.no_data_notice':
        'This report does not contain any data. Please try to run the report with a different group of users or a different time frame.',
    'Report.select_clients': 'Select which clients to report on',
    'ReportBuilder.exclude_tags': 'Exclude tags',
    'ReportBuilder.no_tags': 'Include applications without tags',
    'Reports.AccountsInventory.personal': 'Personal Account',
    'Reports.AccountsInventory.personalAccounts': 'Personal Accounts',
    'Reports.AccountsInventory.service': 'Service Account',
    'Reports.AccountsInventory.serviceAccounts': 'Service Accounts',
    'Reports.AccountsInventory.shared': 'Shared Account',
    'Reports.AccountsInventory.sharedAccounts': 'Shared Accounts',
    'Reports.AccountsInventory.total': 'Total Accounts',
    'Reports.AccountsInventory.work': 'Work Account',
    'Reports.AccountsInventory.workAccounts': 'Work Accounts',
    'Reports.adoption.allUsersInOrg.activeInactive':
        'All Users In Organization, Active Vs. Inactive',
    'Reports.adoption.bottom5Users': 'Bottom 5 Users',
    'Reports.adoption.dailyAveargeOverDays':
        'Daily Average over {{totalDays}} days',
    'Reports.adoption.dailyBreakdown.multipleApps.forPeriod':
        'Daily Breakdown for Multiple Applications between <StartDate/> and <EndDate/>',
    'Reports.adoption.dailyBreakdown.singleApp.forPeriod':
        'Daily Breakdown for {{appName}} between <StartDate/> and <EndDate/>',
    'Reports.adoption.forApp.forMonthly':
        'Product Adoption Report For {{appName}} for {{month}}',
    'Reports.adoption.forApp.forPeriod':
        'Product Adoption Report For {{appName}} between <StartDate/> and <EndDate/>',
    'Reports.adoption.hms.sec.usageOverNumberOvertotalDays':
        '(avg. <HMS/> / day)',
    'Reports.adoption.multipleApps':
        'Product Adoption Report for Multiple Applications',
    'Reports.adoption.orgOverview': 'Organizational Overview',
    'Reports.adoption.orgOverview.item1.multipleApps':
        'Between <StartDate/> and <EndDate/>, {{activeUsers}} users were active in multiple applications and {{inactiveUsers}} users were not.',
    'Reports.adoption.orgOverview.item1.singleApp':
        'Between <StartDate/> and <EndDate/>, {{activeUsers}} users were active in {{appName}} and {{inactiveUsers}} were not.',
    'Reports.adoption.orgOverview.item2':
        'Of the {{activeUsers}} active users, there were',
    'Reports.adoption.orgOverview.item2.subitems': '{{value}} {{type}} users',
    'Reports.adoption.selectApps':
        'Please select an application and re-run this report.',
    'Reports.adoption.top5Users': 'Top 5 Power Users',
    'Reports.adoption.usageVsDaily.multipleApps.forPeriod':
        'Usage vs. Daily Users for Multiple Applications between <StartDate/> and <EndDate/>',
    'Reports.adoption.usageVsDaily.singleApp.forPeriod':
        'Usage vs. Daily Users for {{appName}} between <StartDate/> and <EndDate/>',
    'Reports.adoption.userBreakdown.multipleApps.forPeriod':
        'User Breakdown for Multiple Applications between <StartDate/> and <EndDate/>',
    'Reports.adoption.userBreakdown.singleApp.forPeriod':
        'User Breakdown for {{appName}} between <StartDate/> and <EndDate/>',
    'Reports.advanced_setup': 'Advanced Report Setup',
    'Reports.ApplicationOverlapReport.categoryBreakdown.description':
        'A detailed view of discovered applications grouped by sub-category that may be providing similar functionality helping identify redundancies, usage trends, and potential security concerns. Users and Usage is based on the timeframe selected.',
    'Reports.ApplicationOverlapReport.categoryBreakdown.title':
        'Category Breakdown',
    'Reports.ApplicationOverlapReport.categoryOverview.description':
        'Distribution of application categories that share overlapping tools. Each segment represents a distinct category and its proportion reflects the number of sub-categories with overlapping tools.',
    'Reports.ApplicationOverlapReport.categoryOverview.title':
        'Category Overview',
    'Reports.ApplicationReport.map_breakdown': 'Related Applications Breakdown',
    'Reports.ApplicationReport.map_overview': 'Application Map Top 20',
    'Reports.ApplicationReport.map_overview_usage':
        'Related Applications Usage Comparison (Top 20)',
    'Reports.ApplicationReport.map_overview_users':
        'Related Applications User Comparison (Top 20)',
    'Reports.availableReports': 'Available Reports',
    'Reports.Browser.description':
        'Provides insight into the number of users that are using personal email addresses as their profile on certain web browsers. Using a personal profile in the browser can be risky behaviour as it is a known attack vector for threats and may expose saved or cached sensitive data (like passwords).',
    'Reports.Browser.personal_count':
        'Active Users with Personal Browser Profiles',
    'Reports.Browser.personal_percent':
        '% of Users with Personal Browser Profiles',
    'Reports.Browser.personal_profile': 'Personal Browser Profile',
    'Reports.Browser.profile_breakdown': 'User Browser Profile Breakdown',
    'Reports.Browser.users_with_personal':
        'Users with Personal Browser Profiles',
    'Reports.Browser.users_without_personal':
        'Users without Personal Browser Profiles',
    'Reports.BusinessOwnerReport.business_owner_application_breakdown':
        'Application Breakdown',
    'Reports.BusinessOwnerReport.first_month': '1st Month',
    'Reports.BusinessOwnerReport.quarterUsage': 'Quarter Usage',
    'Reports.BusinessOwnerReport.second_month': '2nd Month',
    'Reports.BusinessOwnerReport.third_month': '3rd Month',
    'Reports.CategoryReport.category_breakdown': 'Category Breakdown',
    'Reports.CategoryReport.category_overview': 'Category Overview',
    'Reports.collapse_all': 'Collapse All',
    'Reports.Contracts.activeUsers': 'Active Users',
    'Reports.Contracts.all': 'All Contracts',
    'Reports.Contracts.contractDate': 'Contract Date',
    'Reports.Contracts.email': 'Email',
    'Reports.Contracts.errorLoadingReportConfiguration':
        'Unable to load report configuration.',
    'Reports.Contracts.firstDetected': 'First Detected',
    'Reports.Contracts.lastUsage30DaysAgo':
        'Last usage was more than 30 days ago.',
    'Reports.Contracts.lastUsed': 'Last Used',
    'Reports.Contracts.monthlyContractValue':
        'Monthly Contract Value by this App',
    'Reports.Contracts.monthToMonth': 'Month to Month',
    'Reports.Contracts.noEventMatch': 'No contracts match the chosen criteria.',
    'Reports.Contracts.percentOfTotalMonthlyValue':
        '<Percent/> of the total monthly value',
    'Reports.Contracts.renewal': 'Renewal',
    'Reports.Contracts.renewalContract': 'Renewal Contract',
    'Reports.Contracts.renewalContracts': 'Renewal Contracts',
    'Reports.Contracts.subscribedUsers': 'Subscribed Users',
    'Reports.Contracts.tableByType': 'Contracts Table by Type',
    'Reports.Contracts.totalContracts': 'Total Contracts',
    'Reports.Contracts.totalContractValue': 'Total Contract Value',
    'Reports.Contracts.totalMonthlyValue': 'Total Monthly Value',
    'Reports.Contracts.type': 'Type',
    'Reports.Contracts.upcomingContracts': 'Upcoming Contracts',
    'Reports.Contracts.user': 'User',
    'Reports.Contracts.usersDetails': 'Users Details for All Applications',
    'Reports.Contracts.usersDetailsAppBreakdown': 'Application Breakdown',
    'Reports.Contracts.usersDetected': 'Users Detected',
    'Reports.Device.detailed_usage': 'Detailed Device Application Usage',
    'Reports.DiscoveryReport.business_owner_assignment_breakdown':
        'Business Owner Assignment Breakdown',
    'Reports.DiscoveryReport.business_owner_assignment_overview':
        'Business Owner Assignment Overview',
    'Reports.DiscoveryReport.discovery_application_breakdown':
        'Application Breakdown',
    'Reports.DiscoveryReport.discovery_overview': 'Overview',
    'Reports.DiscoveryReport.status_assignment_breakdown':
        'Lifecycle Stage Breakdown',
    'Reports.DiscoveryReport.status_assignment_overview':
        'Lifecycle Stage Overview',
    'Reports.DiscoveryReport.tag_assignment_breakdown':
        'Tag Assignment Breakdown',
    'Reports.error_one_report': 'Please select at least one report to be ran.',
    'Reports.error_select_business_owner': 'Please select a business owner.',
    'Reports.errorGettingData': 'Could not retrieve report information.',
    'Reports.expand_all': 'Expand All',
    'Reports.expand_user_details': 'Expand User Details',
    'Reports.LibraryReport.library_overview': 'Library Overview',
    'Reports.my_reports': 'My Reports',
    'Reports.PartnerApplicationOverviewReport.application_breakdown_by_user_count':
        'Application Breakdown by User Count',
    'Reports.PartnerApplicationOverviewReport.application_usage_by_category_breakdown':
        'Applications Used During Quarter by Category Breakdown',
    'Reports.PartnerApplicationOverviewReport.application_usage_by_category_overview':
        'Applications Used by Category Overview',
    'Reports.ProceduralCodes.Account Overview': 'Account Overview',
    'Reports.ProceduralCodes.Account Summary': 'Account Summary',
    'Reports.ProceduralCodes.Accounts Inventory': 'Accounts Inventory Report',
    'Reports.ProceduralCodes.accountsInventory': 'Accounts Inventory Report',
    'Reports.ProceduralCodes.All Reports': 'All Reports',
    'Reports.ProceduralCodes.application': 'Application Map',
    'Reports.ProceduralCodes.Application Breakdown': 'Application Breakdown',
    'Reports.ProceduralCodes.Application Classification Score':
        'Application Classification Score',
    'Reports.ProceduralCodes.Application Lifecycle Stage Report':
        'Application Lifecycle Stage Report',
    'Reports.ProceduralCodes.Application Map': 'Related Applications',
    'Reports.ProceduralCodes.Application Overlap': 'Application Overlap',
    'Reports.ProceduralCodes.Application Overlap Score':
        'Application Overlap Score',
    'Reports.ProceduralCodes.Application Usage': 'Application Usage',
    'Reports.ProceduralCodes.ApplicationBreakdown': 'Application Breakdown',
    'Reports.ProceduralCodes.Applications by Users': 'Applications By Users',
    'Reports.ProceduralCodes.Applications Used': 'Applications Used',
    'Reports.ProceduralCodes.applicationUserDetails':
        'Application User Details',
    'Reports.ProceduralCodes.Breakdown': 'Breakdown',
    'Reports.ProceduralCodes.browser': 'Browser Account Security',
    'Reports.ProceduralCodes.Browser Account Overview':
        'Browser Account Security Reports',
    'Reports.ProceduralCodes.Business Owner Reports': 'Business Owner Reports',
    'Reports.ProceduralCodes.businessOwner': 'Business Owner',
    'Reports.ProceduralCodes.Category Breakdown': 'Category Breakdown',
    'Reports.ProceduralCodes.Category Overview': 'Category Overview',
    'Reports.ProceduralCodes.Category Reports': 'Category Reports',
    'Reports.ProceduralCodes.Client Impact': 'Client Impact',
    'Reports.ProceduralCodes.Contract Insights Report':
        'Contract Insights Report',
    'Reports.ProceduralCodes.Cover Page': 'Cover Page',
    'Reports.ProceduralCodes.daily': 'Daily',
    'Reports.ProceduralCodes.Daily Breakdown': 'Daily Breakdown',
    'Reports.ProceduralCodes.Daily Overview': 'Daily Overview',
    'Reports.ProceduralCodes.device': 'Device',
    'Reports.ProceduralCodes.Device Breakdown Report':
        'Application Usage Per Device',
    'Reports.ProceduralCodes.discovery': 'Discovery',
    'Reports.ProceduralCodes.Discovery Reports': 'Discovery Reports',
    'Reports.ProceduralCodes.First Quarterly Business Reports':
        'First Quarterly Business Reports',
    'Reports.ProceduralCodes.Hourly Breakdown': 'Hourly Breakdown',
    'Reports.ProceduralCodes.individual': 'Personal',
    'Reports.ProceduralCodes.Insights': 'Insights',
    'Reports.ProceduralCodes.Library Changes': 'Library Changes',
    'Reports.ProceduralCodes.Library Reports': 'Library Reports',
    'Reports.ProceduralCodes.license': 'License',
    'Reports.ProceduralCodes.License Breakdown Report':
        'Detailed License Usage',
    'Reports.ProceduralCodes.Lifecycle Stage Report': 'Lifecycle Stage Report',
    'Reports.ProceduralCodes.Managed Application Score':
        'Managed Application Score',
    'Reports.ProceduralCodes.MFA Overview': 'MFA Overview',
    'Reports.ProceduralCodes.MFA Summary': 'MFA Summary',
    'Reports.ProceduralCodes.Microsoft Office Reports':
        'Microsoft Office Overlap Reports',
    'Reports.ProceduralCodes.microsoftOfficeOverlap':
        'Microsoft Office Overlap',
    'Reports.ProceduralCodes.monthly': 'Monthly',
    'Reports.ProceduralCodes.No Overlap Breakdown':
        'No Overlap Overview Breakdown',
    'Reports.ProceduralCodes.Notes & Recommendations':
        'Notes & Recommendations',
    'Reports.ProceduralCodes.offboard': 'Offboard Reports',
    'Reports.ProceduralCodes.Organization Report': 'Organization Report',
    'Reports.ProceduralCodes.organizational': 'Organizational',
    'Reports.ProceduralCodes.Overview': 'Overview',
    'Reports.ProceduralCodes.Overview Breakdown': 'Overview Breakdown',
    'Reports.ProceduralCodes.OverviewBreakdown': 'Overview Breakdown',
    'Reports.ProceduralCodes.partnerApplicationOverview':
        'Partner Application Overview',
    'Reports.ProceduralCodes.partnerBreachImpact': 'Partner Vendor Incident',
    'Reports.ProceduralCodes.partnerUsers': 'Partner User Inventory',
    'Reports.ProceduralCodes.period': 'Date Range',
    'Reports.ProceduralCodes.Personal Report': 'Personal Report',
    'Reports.ProceduralCodes.Product Adoption Report':
        'Product Adoption Report',
    'Reports.ProceduralCodes.productAdoption': 'Product Adoption',
    // Remove once the BE has been deployed BE: SAAS-1179
    'Reports.ProceduralCodes.Production Adoption Reports':
        'Product Adoption Report',
    'Reports.ProceduralCodes.qbr': 'Quarterly Business',
    'Reports.ProceduralCodes.quarterly': 'Quarterly',
    'Reports.ProceduralCodes.Risk Analysis': 'Risk Analysis',
    'Reports.ProceduralCodes.SaaS Health Score': 'SaaS Health Score',
    'Reports.ProceduralCodes.Shadow IT Score': 'Shadow IT Score',
    'Reports.ProceduralCodes.shadowIT': 'Shadow IT',
    'Reports.ProceduralCodes.ShadowIT Report': 'ShadowIT Report',
    'Reports.ProceduralCodes.status': 'Lifecycle Stage',
    'Reports.ProceduralCodes.Un-Approved Application Usage Score':
        'Un-Approved Application Usage Score',
    'Reports.ProceduralCodes.Usage And Overlap': 'Usage And Overlap',
    'Reports.ProceduralCodes.Usage Reports': 'Usage Reports',
    'Reports.ProceduralCodes.Usage Vs Adoption': 'Usage vs Adoption',
    'Reports.ProceduralCodes.User Breakdown Report':
        'Application Usage Per User',
    'Reports.ProceduralCodes.User Inventory': 'User Inventory',
    'Reports.ProceduralCodes.User Lifecycle Stage Report':
        'User Lifecycle Stage Report',
    'Reports.ProceduralCodes.User Offboard Report': 'Offboard Reports',
    'Reports.ProceduralCodes.userApps': 'User Applications',
    'Reports.ProceduralCodes.weekly': 'Weekly',
    'Reports.ProceduralCodes.Workflow Configuration Score':
        'Workflow Configuration Score',
    'Reports.prompt_crunching_report':
        'Currently Crunching Your Personalized Report!',
    'Reports.remove_inactive': 'Remove inactivity from report',
    'Reports.remove_personal': 'Remove personal applications from report',
    'Reports.remove_unanalyzed': 'Remove unanalyzed applications from report',
    'Reports.remove_unclassified':
        'Remove unclassified applications from report',
    'Reports.removeBrowser': 'Remove browsers from report',
    'Reports.removeDormant': 'Remove dormant accounts from report',
    'Reports.removePersonalAccounts': 'Remove personal accounts from report',
    'Reports.report_applications': 'Application Reports',
    'Reports.report_category': 'Category Breakdown',
    'Reports.report_device': 'Device Reports',
    'Reports.report_discovery': 'Discovery Report',
    'Reports.report_library': 'Library Report',
    'Reports.report_license': 'License Reports',
    'Reports.report_offboard': 'Offboard Reports',
    'Reports.report_setup': 'Report Setup',
    'Reports.report_ShadowIT': 'ShadowIT Reports',
    'Reports.report_status': 'Lifecycle Stage Reports',
    'Reports.report_usage': 'Usage Overview',
    'Reports.ReportBuilder.all': 'All',
    'Reports.ReportBuilder.all_users_and_groups': 'All users / groups',
    'Reports.ReportBuilder.applications_platforms': 'Applications platforms',
    'Reports.ReportBuilder.approved': 'Approved',
    'Reports.ReportBuilder.certain_applications': 'Select applications',
    'Reports.ReportBuilder.certain_categories': 'Select categories',
    'Reports.ReportBuilder.certain_groups': 'Select certain groups',
    'Reports.ReportBuilder.certain_management_stage': 'Select management stage',
    'Reports.ReportBuilder.certain_statuses': 'Select lifecycle stage',
    'Reports.ReportBuilder.certain_users': 'Select certain users',
    'Reports.ReportBuilder.narrow_applications':
        'Select which applications to report on',
    'Reports.ReportBuilder.narrow_status':
        'Select which application lifecycle stage to report on',
    'Reports.ReportBuilder.narrow_users': 'Select which user(s) to report on',
    'Reports.ReportBuilder.not_approved': 'Unapproved',
    'Reports.ReportBuilder.not_configured': 'Not configured',
    'Reports.ReportBuilder.overview_matrix_tags':
        'Select tags to show in overview matrix',
    'Reports.ReportBuilder.select_business_owner': 'Select business owner',
    'Reports.ReportBuilder.select_day': 'Select the day to run your report on',
    'Reports.ReportBuilder.select_end': 'Select your ending period',
    'Reports.ReportBuilder.select_month':
        'Select the month to run your report on',
    'Reports.ReportBuilder.select_period': 'Select your report period',
    'Reports.ReportBuilder.select_quarter': 'Select report quarter',
    'Reports.ReportBuilder.select_start': 'Select your starting period',
    'Reports.ReportBuilder.select_sub_report': 'Select your sub-report options',
    'Reports.ReportBuilder.select_type': 'Select Your Report Type',
    'Reports.ReportBuilder.select_user': 'Select which user to report on',
    'Reports.ReportBuilder.select_week': 'Select a week to run your report on',
    'Reports.ReportBuilder.tooManyAppsWarning':
        'Reports may not render well with more than 5 applications selected for the Product Adoption report.',
    'Reports.ReportSummary.advanced_report_details': 'Advanced Report Details',
    'Reports.ReportSummary.sub_reports': 'Sub-Reports',
    'Reports.run_report': 'Run Report',
    'Reports.save_and_schedule': 'Save & Schedule Report',
    'Reports.Schedule.error': 'Error scheduling report.',
    'Reports.Schedule.error_select_user':
        'You must select a user/email to send the report to.',
    'Reports.Schedule.select_user_email':
        'Select User OR Enter Email to Send Report To',
    'Reports.Schedule.success': 'Your report has been saved.',
    'Reports.ScheduledReport.error_loading_reports':
        'Issue loading scheduled reports.',
    'Reports.ScheduledReport.error_removing_report':
        'There was an issue removing this report from your dashboard.',
    'Reports.ScheduledReport.report_configuration': 'Report Configuration',
    'Reports.ScheduledReport.success_remove':
        'Successfully removed this report from your dashboard.',
    'Reports.ScheduledReport.view_full_report':
        'View Full Report Configuration',
    'Reports.scheduledReports': 'Scheduled Reports',
    'Reports.Title.accountsInventory.report': 'Accounts Inventory',
    'Reports.Title.application.report': 'Application Map Report',
    'Reports.Title.applicationFunnel.report': 'Application Funnel Report',
    'Reports.Title.applicationOverlap.report': 'Application Overlap Report',
    'Reports.Title.browser': 'Browser Account Security',
    'Reports.Title.browser.report': 'Browser Account Security Report',
    'Reports.Title.businessOwner.report': 'Business Owner Report',
    'Reports.Title.contracts': 'Contract Insights',
    'Reports.Title.contracts.report': 'Contract Insights Report',
    'Reports.Title.device.report': 'Device Report',
    'Reports.Title.discovery.report': 'Discovery Report',
    'Reports.Title.microsoftOfficeOverlap.report':
        'Microsoft Office Overlap Report',
    'Reports.Title.offboard.report': 'Offboard Report',
    'Reports.Title.organizational.report': 'Organizational Usage Report',
    'Reports.Title.partnerApplicationOverview.report':
        'Partner Application Overview Report',
    'Reports.Title.partnerApplicationUsage.report':
        'Partner Application Usage Report',
    'Reports.Title.partnerBreachImpact.report': 'Vendor Incident Impact Report',
    'Reports.Title.partnerClientDeploymentStage.report':
        'Partner Client Deployment Stage Report',
    'Reports.Title.partnerUsers.report': 'Partner User Inventory Report',
    'Reports.Title.productAdoption.report': 'Product Adoption Report',
    'Reports.Title.qbr.report': 'Quarterly Business Report',
    'Reports.Title.shadowIT.report': 'Shadow IT Report',
    'Reports.Title.status.report':
        'Application Lifecycle Stage Breakdown Report',
    'Reports.Title.userApps': 'User Application Inventory',
    'Reports.Title.userApps.report': 'User Application Inventory Report',
    'Reports.UsageReport.adoption_and_usage': 'Application Adoption and Usage',
    'Reports.UsageReport.application_users': 'Application Users',
    'Reports.UsageReport.applications': 'Applications',
    'Reports.UsageReport.applicationsDiscovered': 'Applications Discovered',
    'Reports.UsageReport.average_usage': 'Average Usage (Usage / Users)',
    'Reports.UsageReport.averageUsagePerUser': 'Average Usage Per User (Hours)',
    'Reports.UsageReport.usage_breakdown': 'Usage Breakdown',
    'Reports.UsageReport.usage_daily_breakdown': 'Usage Daily Breakdown',
    'Reports.UsageReport.usage_overview': 'Usage Overview',
    'Reports.UsageReport.usageAdoption.graph.subtitle':
        'A comprehensive view of user engagement alongside the growth in application footprint. This chart showcases the average application usage per use (total apps discovered by total users) alongside the daily count of newly discovered applications based on the time frame selected. Use this to provide visibility into software growth, user engagement and potential trends of sprawl or underutilization.',
    'Reports.UsageReport.usageAdoption.table.subtitle':
        'This table lists all applications discovered in your environment during the selected time frame. Applications identified via Quick Scan may not yet show usage data, as this is collected retroactively. Usage metrics will appear once sufficient data has been gathered.',
    'Reports.UsageReport.usageHours': 'Usage (Hours)',
    'Reports.UserApps.description':
        'Gain a full understanding of which users are using each application within the business.',
    'Reports.view_advanced_setup': 'View Advanced Report Setup',
    'ReportSelection.title': 'Reports'
};
